<template>
  <v-autocomplete
    hide-details="auto"
    :items="brands"
    :loading="loadingBrand"
    v-model="filterDatas.brand"
    item-text="name"
    item-value="id"
    label="Brand"
    outlined
    dense
    clearable
    @change="emitInput(filterDatas.brand)"
    :search-input.sync="searchBrand"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    brands: [],
    selectBrand: null,
    searchBrand: null,
    loadingBrand: false,
  }),
  methods: {
    emitInput(data) {
      if (this.filterDatas.isrouteNewPage == false) {
        this.$store.commit('UPDATE_BRAND_FILTER', data);
        this.$emit('input', this.filterDatas.brand);
      } else {
        this.$emit('input', data);
      }
    },
    getBrandsByQuery(query = '') {
      this.projectsLoading = true;
      this.$store
        .dispatch('brand/GetBrandSearch', {
          query:
            this.filterDatas.isrouteNewPage == false
              ? this.filterDatas.brandquery
              : query,
        })
        .then((res) => {
          this.brands = res.data;
          this.loadingBrand = false;
        })
        .catch((err) => {
          this.loadingBrand = false;
          this.messages = err.data.title;
        });
    },
  },
  computed: {
    ...mapState(['filterDatas']),
  },
  watch: {
    clear: {
      handler(val) {
        this.selectBrand = null;
      },

      deep: true,
    },
    searchBrand: {
      handler(val) {
        if (this.filterDatas.isrouteNewPage == false) {
          this.$store.commit('UPDATE_BRAND_QUERY_FILTER', val);
        }
        this.getBrandsByQuery(val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.filterDatas.isrouteNewPage == false) {
      this.selectBrand = this.filterDatas.brand;
      this.$emit('input', this.filterDatas.brand);
    }
  },
  created() {
    this.getBrandsByQuery();
  },
};
</script>
